goog.provide("shadow.js.shim.module$ol$source$XYZ$default");
shadow.js.shim.module$ol$source$XYZ$default = shadow.js.require(409, {})["default"];
